import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from '@lingui/core/macro';
import { classnames, ValidatingInput, ValidatingInputProps } from '@ygtechnologies/bygr-frontend-component-library';
import React, { PropsWithChildren, useState } from 'react';
import { TranslatableText } from '@/types';
import theme from './UserPageInput.module.scss';

interface WrapperProps extends PropsWithChildren {
    label: TranslatableText;
}

export const UserPageInputWrapper: React.FC<WrapperProps> = ({ label, children }) => {
    return (
        <label className={theme.container}>
            <span>{label}</span>
            {children}
        </label>
    );
};

type OwnProps = ValidatingInputProps & WrapperProps;
const UserPageInput = React.forwardRef<HTMLInputElement, OwnProps>(
    ({ label, fieldName, placeholder, ...inputProps }, ref) => {
        const [showPassword, setShowPassword] = useState(false);

        return (
            <UserPageInputWrapper label={label}>
                <div className={theme.inputContainer}>
                    <ValidatingInput
                        {...inputProps}
                        fieldName={fieldName || placeholder || label}
                        placeholder={placeholder}
                        className={classnames(theme.inputSpacing, 'form-control')}
                        type={showPassword ? 'text' : inputProps.type}
                        ref={ref}
                    />
                    {inputProps.type === 'password' && (
                        <span
                            className={classnames(theme.passwordIcon, { [theme.showPasswords]: showPassword })}
                            aria-checked={showPassword}
                            onClick={() => {
                                setShowPassword(!showPassword);
                            }}>
                            <FontAwesomeIcon title={t`Show password`} icon={showPassword ? faEye : faEyeSlash} />
                        </span>
                    )}
                </div>
            </UserPageInputWrapper>
        );
    }
);

export default UserPageInput;
